var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Main'),_c('Intro'),_c('Vision'),_c('AboutUs'),_c('Projects'),_c('Events'),_c('Network'),_c('Newsletter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }